import { useEffect } from 'react';

/**
 * Custom hook to handle ESC key for closing popups or showing pause menu
 * @param {Object} popupStates - Object containing all popup state values
 * @param {Object} popupSetters - Object containing all popup setter functions
 */
export function useKeydownListener(popupStates, popupSetters) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        
        // Priority order: close popups first, then show pause menu
        if (popupStates.showNuclearStatusReport) {
          // Nuclear status report can't be closed with ESC (mandatory)
          return;
        } else if (popupStates.deployTroopsConfirmation) {
          popupSetters.setDeployTroopsConfirmation(null);
        } else if (popupStates.enrichmentWarning) {
          popupSetters.setEnrichmentWarning(null);
        } else if (popupStates.showStatusReport) {
          popupSetters.setShowStatusReport(false);
        } else if (popupStates.nukeReadyCelebration) {
          popupSetters.setNukeReadyCelebration(null);
        } else if (popupStates.showPauseMenu) {
          popupSetters.setShowPauseMenu(false);
        } else {
          // No popups open, show pause menu
          popupSetters.setShowPauseMenu(true);
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [
    popupStates.deployTroopsConfirmation,
    popupStates.enrichmentWarning,
    popupStates.showStatusReport,
    popupStates.nukeReadyCelebration,
    popupStates.showPauseMenu,
    popupStates.showNuclearStatusReport
  ]);
}
